import { AxiosError } from 'axios';
import { useState } from 'react';

import { DashboardStatsDataInterface } from '../../../models/dashboard/dashboard/dashboard-stats';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { dashboardStatsActions } from '../../../redux/slices/dashboardStatsSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useDashboardStats = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onGetDashboardStatsError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onGetDashboardStatsSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<DashboardStatsDataInterface>) => {
        dispatch(dashboardStatsActions.setDashboardStatsData(data));
    };

    const getDashboardStats = async () => {
        const url: HttpConfig = {
            url: `api/v1/company/overview-metrics`,
            method: 'get',
        };

        return request(url, onGetDashboardStatsSuccess, setLoading, onGetDashboardStatsError);
    };

    return { getDashboardStats, loading };
};

export default useDashboardStats;
